import React from 'react';

interface WeatherFactsProps {
  published: boolean;
  categories: [
    {
      title: string;
      details: string;
      image: string;
      name: string;
      job: string;
    }
  ];
}

interface WeatherFactsPropsWrapper {
  weatherFacts: WeatherFactsProps;
}
const WeatherFacts = (props: WeatherFactsPropsWrapper) => {
  const { weatherFacts } = props;
  return (
    <div className="container">
      <section>
        {weatherFacts?.published && (
          <div className="weather-facts">
            <div className="weather-facts-inner">
              <h1 className="type-center">
                {weatherFacts.categories[0].title}
              </h1>
              <p className="type-center type-balance">
                {weatherFacts.categories[0].details}
              </p>
              <img
                src={weatherFacts.categories[0].image}
                alt={weatherFacts.categories[0].name}
              />
              <h3>{weatherFacts.categories[0].name}</h3>
              <p className="type-center type-balance">
                {weatherFacts.categories[0].job}
              </p>
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default WeatherFacts;
